angular.module("vgresiduos").controller("PgrsEditCtrl", [
	"$rootScope",
	"$stateParams",
	function ($rootScope, $stateParams) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, `declaracoes/pgrs/${$stateParams.pgrsId}/editar`);
		};
	}
]);
